import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import { ErrorPage } from '../components/ErrorPage/index.js';
import { Provider } from 'react-redux';
import { i18n } from '../i18n/translate.js';
var ErrorBoundedProvider = /*#__PURE__*/function (_Component) {
  function ErrorBoundedProvider(props) {
    var _this;
    _classCallCheck(this, ErrorBoundedProvider);
    _this = _callSuper(this, ErrorBoundedProvider, [props]);
    _this.state = {};
    return _this;
  }
  _inherits(ErrorBoundedProvider, _Component);
  return _createClass(ErrorBoundedProvider, [{
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        // render fallback UI
        var errorMessage = /*#__PURE__*/React.createElement(React.Fragment, null, i18n.t("Please try to refresh this page. If that doesn't work you can go to "), /*#__PURE__*/React.createElement("a", {
          href: "https://everfihelp.force.com/foundry/s/",
          target: "_blank",
          rel: "noopener noreferrer"
        }, i18n.t('this page')), ' ', i18n.t('for help.'));
        return /*#__PURE__*/React.createElement(ErrorPage, {
          renderAsLegacy: true,
          errors: [errorMessage],
          title: i18n.t('Something Went Wrong.')
        });
      }

      // when there's not an error, render children untouched
      return /*#__PURE__*/React.createElement(Provider, this.props);
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);
}(Component);
ErrorBoundedProvider.displayName = "ErrorBoundedProvider";
export { ErrorBoundedProvider };